import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Container, Grid, GridColumn} from "semantic-ui-react";

class EligibilityRequirements extends PureComponent {
  static propTypes = {
    show: PropTypes.object.isRequired,
    season: PropTypes.object.isRequired,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  
  render() {
    const { show, season } = this.props;

    return (
      <div>
        <Container id="mainContent" className="ui">
          <Grid className="ui">
            <GridColumn className="pageShowTitle">
              <h3
                className="ui dividing header"
                style={{ color: `#${season.hexColorCodeC}` }}
              >
                {show.name} Casting
              </h3>
            </GridColumn>
          </Grid>

          <Grid className="ui stackable">
            <GridColumn className="ui sixteen wide">
              <h1>Eligibility Requirements</h1>

              <style>{"\
                .inner-html a {\
                  color:#" + season.hexColorCodeC + " !important;\
                }\
              "}</style>

              <div className="inner-html" dangerouslySetInnerHTML={{  __html: season.eligibilityRequirementsC }} />
              
            </GridColumn>
          </Grid>
        </Container>
      </div>
    );
  }
}

const mapStatesToProps = (state, ownProps) => ownProps;

export default connect(mapStatesToProps)(EligibilityRequirements);



// WEBPACK FOOTER //
// ./src/components/EligibilityRequirements.js